import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loaded: false,
  isApprover: false,
  isAdmin: false,
  level: null,
  levelNumber: null,
  levelTitle: null,
  userName: null,
  userId: null,
  pendingCount: 0
};

const transportAdvisoryAccessSlice = createSlice({
  name: "transportAdvisoryAccess",
  initialState,
  reducers: {
    setTransportAdvisoryAccess: (state, action) => ({
      ...state,
      loaded: true,
      isApprover: !!action.payload?.isApprover,
      isAdmin: !!action.payload?.isAdmin,
      level: action.payload?.level ?? null,
      levelNumber: action.payload?.levelNumber ?? null,
      levelTitle: action.payload?.levelTitle ?? null,
      userName: action.payload?.userName ?? null,
      userId: action.payload?.userId ?? null,
      pendingCount: action.payload?.pendingCount ?? 0
    }),
    updatePendingCount: (state, action) => {
      state.pendingCount = action.payload;
    },
    setTestMode: (state, action) => {
      state.isTestMode = action.payload;
    },
    resetTransportAdvisoryAccess: () => ({ ...initialState, loaded: true })
  }
});

export const {
  setTransportAdvisoryAccess,
  updatePendingCount,
  setTestMode,
  resetTransportAdvisoryAccess
} = transportAdvisoryAccessSlice.actions;

export default transportAdvisoryAccessSlice.reducer;
